﻿import { extend } from './helpers.js';
export default class TagFilter {

    constructor(element, options) {

        const defaults = {
            listWrapper: element.nextElementSibling,
            onFiltered: function () { },
            autoInit: true
        };

        this._element = element;
        this._allowMultiple = element.getAttribute('data-filter-allow-multiple') === 'true';
        this._matchAll = element.getAttribute('data-filter-match-all') === 'true';        
        this._options = extend(defaults, options);
        this.activeTags = [];

        if (this._options.autoInit)
            this.init();
    }

    init() {
        const base = this;

        base._element.querySelectorAll('a').forEach(anchor => {

            anchor.addEventListener('click', evt => {
                evt.preventDefault();
                var hash = evt.target.getAttribute('href');
                if (evt.target.classList.contains('active')) {                    
                    base.activeTags = base.activeTags.filter(function (item) {
                        return item !== hash;
                    });
                }
                else {

                    if (!base._allowMultiple)
                        base.activeTags = [];

                    base.activeTags.push(hash);
                }

                window.history.pushState('', document.title, window.location.pathname + base.getCombinedHash());

                base.filterList();
            });
        });

        if (this._options.autoInit) {
            window.addEventListener('pageshow', (event) => {
                base.filterList();
            });
        }
        else {
            base.filterList();
        }
    }

    getCombinedHash() {
        const base = this;

        if (base.activeTags.length === 0)
            return '';

        if (base.activeTags.length === 1)
            return base.activeTags[0];

        return base.activeTags.join('|');
    }

    filterList() {
        const base = this;

        // If no tags active, check in the url
        if (base.activeTags.length == 0) {
            var hash = decodeURIComponent(window.location.hash);
            if (hash && hash.length > 0) {
                var items = hash.split('|');
                for (var i = 0; i < items.length; i++) {
                    base.activeTags.push(items[i]);
                }
            }
        }

        // Manage filter buttons
        base._element.querySelectorAll('a').forEach(anchor => {
            anchor.classList.remove('active');

            for (var i = 0; i < base.activeTags.length; i++) {
                if (anchor.getAttribute('href') === base.activeTags[i])
                    anchor.classList.add('active');
            }
        });
                
        // Clear filters
        if (base.activeTags.length === 0) {
            base._options.listWrapper.querySelectorAll('*[data-tags]').forEach(element => { element.classList.remove('d-none'); });
            base._options.onFiltered();
            return;
        }

        // Filter
        base._options.listWrapper.querySelectorAll('*[data-tags]').forEach(element => {

            element.classList.add('d-none');

            let visible = false;
            for (var i = 0; i < base.activeTags.length; i++) {
                let tag = base.activeTags[i].replace('#', '');

                if (element.getAttribute('data-tags').indexOf(tag) > -1) {
                    visible = true;

                    if (!base._matchAll)
                        break;
                } else if (base._matchAll) {
                    visible = false;
                    break;
                }
            }

            if (visible === true) {
                element.classList.remove('d-none');
            }
        });

        base._options.onFiltered();
    }
};